export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Oturum aç",
    "login.form.hint.user": "Giriş",
    "login.form.hint.password": "Şifre",
    "login.form.checkbox.remember-me": "Beni hatırla",
    "login.form.button.sign-in": "Oturum aç",
    "login.form.message.invalid-user-credentials": "Giriş bilgisi veya parola hatalı",
    "login.form.message.user-required": "Giriş bilgisi girin",
    "login.form.message.password-required": "Parola girin",
    "login.form.button.forgot-password": "Şifrenizi mi unuttunuz?",
    "error.root-admin-login.title": "Hata 403 – Yasaklı",
    "error.root-admin-login.message": "Salt Okunur Yönetici olarak oturum açtınız. Web Recovery konsoluna erişmek için lütfen bu kullanıcı yerine müşteri kiracı kullanıcısı veya yöneticisi olarak oturum açın"
};
